import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=080e69b8"
import script from "./AlertDetails.vue?vue&type=script&lang=js"
export * from "./AlertDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports